import { render, staticRenderFns } from "./download-modal.vue?vue&type=template&id=53b86bd6&scoped=true"
import script from "./download-modal.vue?vue&type=script&lang=js"
export * from "./download-modal.vue?vue&type=script&lang=js"
import style0 from "./download-modal.vue?vue&type=style&index=0&id=53b86bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b86bd6",
  null
  
)

export default component.exports